module.exports = __webpack_public_path__ + "img/misosuppemithintergrund.2d5c400e.jpg";